import React, { Component } from 'react'
import { connect } from 'react-redux'
import { validateGuestdetail, popupOpenClose } from '../../../action/action'
import { getremoteAccessToken } from '../../../action/tvChannelAction'
import { setTVLoginPage } from '../../action/TVAction2'
import { tvWidgetColors } from '../../JS/colorConfig'
import { getDefaultAnalyticsLabel } from '../../JS/utility'
import { sendAnalytics } from '../../../action/homeAction'

class TVLoginPage extends Component {

    componentDidMount() {
        tvWidgetColors(this.props.menuColor)
    }
    callBackFunc = (status, room, locationId) => {
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
        if (status) {
            this.props.setTVLoginPage(false);
            localStorage.setItem("room", room);
            if (!this.props.currentTv.remoteSessionToken) {
                this.props.getremoteAccessToken(this.props.roomRemoteDetails, this.callBackForColor);
            }

            this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - success",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );
        } else {
            this.props.popupOpenClose(true, "Oops Something went wrong, Please try after some time.")

            this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - failed",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );
        }
    }
    submiForm = () => {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let lname = document.getElementById("lname").value;
        let roomNumber = document.getElementById("roomNumber").value;

        if (SessionToken && lname && roomNumber) {
            this.props.validateGuestdetail(lname, roomNumber, this.callBackFunc, SessionToken);
        }
    }
    render() {
        return (
            <div class="main-container background-overlay" style={{ background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat; background-size: cover;background-attachment: fixed;" }}>
                <header class="inner-pages w-footer subpages">
                    <a href="javascript:window.history.back(-1);" class="button-back"></a>
                    <div class="heading align-center">
                        <p class="bold">TV Remote</p>
                    </div>
                </header>
                <section id="tvControls" class="widgets margin-0 padding-top-1 container-bg" style={{ background: "url('theme/images/background/remote-setupbg-1@3x.png') center bottom no-repeat; background-size: contain;" }}>
                    <div class="widgets">
                        <div id="pairInput" class="row">
                            <p><strong>Use your phone as a remote.</strong></p>
                            <p>First, make sure you are connected to our Wi-Fi</p>
                            <form>
                                <div class="form-row">
                                    <label for="lname">Last Name</label>
                                    <input style={{border:"1px solid #ccc",paddingLeft:"5px",height:"25px"}} id="lname" type="text" name="lname" placeholder="Enter your last name" />
                                </div>
                                <div class="form-row">
                                    <label for="roomNumber">Room Number</label>
                                    <input style={{border:"1px solid #ccc",paddingLeft:"5px",height:"25px"}} id="roomNumber" type="text" name="roomNumber" placeholder="Enter your room number" />
                                </div>
                                <div class="form-controls">
                                    <input onClick={this.submiForm} name="submit" value="Submit" class="button" />
                                </div>
                            </form>
                        </div>

                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        menuColor: state.store.home.MenuColor,
        currentWidget: state.store.sideNavBar.currentWidget,
        roomRemoteDetails: state.store.tvChannels.roomRemoteDetails,
        currentTv: state.store.tvChannels.currentTv,
        currentHomePage: state.store2.currentHomePage,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,

    }
}
export default connect(
    mapStateToProps,
    {
        validateGuestdetail,
        setTVLoginPage,
        popupOpenClose,
        getremoteAccessToken,
        sendAnalytics
    }
)(TVLoginPage);